<template>
  <CardModule title="Variantes do Produto">
    <v-row>
      <v-col cols="6">
        <v-checkbox
          v-model="$produtos_gerenciar.cadastro.variacoes.tem_variacoes"
          label="Este produto tem várias opções."
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
          hide-details
        >
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row v-if="$produtos_gerenciar.cadastro.variacoes.tem_variacoes">
      <v-col cols="12">
        <VariantOption
          :option="variante"
          :idx="index"
          v-for="(variante, index) in $produtos_gerenciar.cadastro.variacoes
            .opcoes"
          :key="index"
        />
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <div
      class="produtos-add-edit-container1 row-container"
      v-if="$produtos_gerenciar.cadastro.variacoes.tem_variacoes"
    >
      <div class="produtos-variacoes-container">
        <div class="produtos-variacoes-container1">
          <v-btn
            height="45"
            class="button btn-border"
            :disabled="
              $produtos_gerenciar.cadastro.variacoes.opcoes.length == 3
            "
            @click="adicionarOpcao"
          >
            <v-icon dark>
              {{ $config.icons.plus }}
            </v-icon>
            <span
              class="produtos-variacoes-text1"
              v-if="$produtos_gerenciar.cadastro.variacoes.opcoes.length <= 3"
              >Adicionar outra opção</span
            >
            <span class="produtos-variacoes-text1" v-else>Adicionar opção</span>
          </v-btn>
        </div>
        <h1
          class="produtos-add-edit-header-variacao"
          v-if="
            $produtos_gerenciar.cadastro.variacoes.variacoes_produtos.length >=
            1
          "
        >
          Variações do produto
        </h1>
        <v-divider
          v-if="
            $produtos_gerenciar.cadastro.variacoes.variacoes_produtos.length >=
            1
          "
        ></v-divider>
        <div
          class="produtos-variacoes-container2"
          v-if="
            $produtos_gerenciar.cadastro.variacoes.variacoes_produtos.length >=
            1
          "
        >
          <div class="input-row-start">
            <div class="produtos-add-edit-container2">
              <div class="produtos-add-edit-container3">
                <div class="produtos-add-edit-container4">
                  <div class="produtos-add-edit-container5 secondary">
                    <v-checkbox
                      v-model="
                        $produtos_gerenciar.cadastro.variacoes.gerenciar_lote
                      "
                      :disabled="
                        $produtos_gerenciar.cadastro.dados_cadastrais.tipo ===
                        'VOUCHER'
                      "
                      label="Ativar gerenciamento por lote."
                      class="checkbox-redes"
                    ></v-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <v-data-table
            class="table-body"
            :headers="headersVariantes"
            :items="tableValues"
            :items-per-page="10"
            :footer-props="{
              itemsPerPageOptions: [10, 20, 50],
              itemsPerPageText: 'Variações por página:',
            }"
          >
            <template v-slot:item.preco="{ item }">
              {{ item.preco | moeda }}
            </template>
            <template v-slot:item.actions="{ item }" class="table-actions">
              <div style="display: flex; justify-content: center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      class="produtos-variacao-button1 button button-bg"
                      v-bind="attrs"
                      v-on="on"
                      width="30"
                      x-small
                      dark
                      @click="editItem(item)"
                    >
                      <EditIcon />
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      class="produtos-variacao-button2 button button-bg"
                      v-bind="attrs"
                      v-on="on"
                      width="30"
                      x-small
                      dark
                      @click="deleteItem(item)"
                    >
                      <DeleteIcon />
                    </v-btn>
                  </template>
                  <span>Deletar</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
    <EditVariantDialog
      :dialog="dialog"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      :defaultItem="defaultItem"
      @close="closeEdit"
    />
    <ModalDeletarVariacao
      :dialogDelete="dialogDelete"
      :deletedItem="deletedItem"
      :deletedIndex="deletedIndex"
      :defaultItem="defaultItem"
      @close="closeDelete"
    />
  </CardModule>
</template>

<script>
import VariantOption from "@/components/produtos/gerenciar/variants/VariantOption.vue";
import ModalDeletarVariacao from "@/components/produtos/gerenciar/variants/modal-deletar-variacao.vue";
import EditVariantDialog from "@/components/produtos/gerenciar/variants/EditVariantDialog.vue";
import EditIcon from "@/components/icons/EditIcon.vue";
import DeleteIcon from "@/components/icons/DeleteIcon.vue";
import products from "@/mixins/products.js";
import { v1, v4 } from "uuid";
import _ from "lodash";
import CardModule from "../../cards/CardModule.vue";

export default {
  name: "Variants",
  mixins: [products],
  components: {
    VariantOption,
    ModalDeletarVariacao,
    EditVariantDialog,
    EditIcon,
    DeleteIcon,
    CardModule,
  },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      deletedIndex: -1,
      editedItem: {
        descricao: "",
        preco: 0,
        quantidade: 0,
        sku: 0,
        status: 0,
        idprod_var_lote: "",
        taxa: "",
      },
      deletedItem: {
        descricao: "",
        preco: 0,
        quantidade: 0,
        sku: 0,
        status: 0,
        idprod_var_lote: "",
      },
      defaultItem: {
        descricao: "",
        preco: 0,
        quantidade: 0,
        sku: 0,
        status: 0,
        idprod_var_lote: "",
      },
    };
  },
  methods: {
    /**
     * @description Método que adiciona opção de variação
     */
    adicionarOpcao() {
      if (this.$produtos_gerenciar.cadastro.variacoes.opcoes.length == 3) {
        this.$config.alert(
          "Produto atingiu o número máximo de opções!",
          this.$config.dados.errorColor
        );
      } else {
        this.$produtos_gerenciar.cadastro.variacoes.opcoes.push({
          tipo: "",
          valor: [
            {
              tem_traducao: false,
              descricao: "",
              descricao_en_us: "",
              descricao_es_es: "",
              preco_default: "",
              qtd_default: "",
              prioridade: "",
              identificador: v4(),
              taxa: "",
            },
          ],
        });
      }
    },
    /**
     * @description Método que traduz descrição da variação
     */
    translateDescription(value) {
      if (
        !value.includes("<pt_BR>") ||
        !value.includes("<en_US>") ||
        !value.includes("<es_ES>")
      ) {
        return {
          pt: value,
          en: value,
          es: value,
        };
      }

      const descPT = value.substring(
        value.indexOf("<pt_BR>") + 7,
        value.indexOf("</pt_BR>")
      );
      const descEN = value.substring(
        value.indexOf("<en_US>") + 7,
        value.indexOf("</en_US>")
      );
      const descES = value.substring(
        value.indexOf("<es_ES>") + 7,
        value.indexOf("</es_ES>")
      );
      return {
        pt: descPT,
        en: descEN,
        es: descES,
      };
    },
    /**
     * @description Método que abre modal de edição de variação
     */
    editItem(item) {
      this.editedIndex =
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos.indexOf(
          item
        );
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    /**
     * @description Método que abre modal de deleção de variação
     */
    deleteItem(item) {
      this.deletedIndex =
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos.indexOf(
          item
        );
      this.deletedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    /**
     * @description Método que fecha modal de edição
     */
    closeEdit() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    /**
     * @description Método que fecha modal de deleção
     */
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.deletedIndex = -1;
      });
    },
  },
  computed: {
    /**
     * @description Propriedade computada que remove tags de tradução das variações e transforma o preço em REAL - (moeda brasileira)
     */
    tableValues() {
      this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos.forEach(
        item => {
          item.descricao = this.$config.convertTagString(item.descricao);
          // item.preco = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2 }).format(item.preco)
        }
      );

      return _.orderBy(
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos,
        "descricao"
      );
    },
  },
  watch: {
    /**
     * @description Observador que monitora mudança no array de opções e gera as variações
     */
    "$produtos_gerenciar.cadastro.variacoes.opcoes": function (e) {
      let variacao = [];
      const variacao2 = [];
      const variacao3 = [];

      e.forEach((element, index) => {
        if (index == 0) {
          element.valor.forEach(item => {
            if (item.descricao != "") {
              variacao.push({
                descricao: `<pt_BR>${item.descricao}</pt_BR><en_US>${item.descricao_en_us}</en_US><es_ES>${item.descricao_es_es}</es_ES>`,
                sku: this.$produtos_gerenciar.SKUGenerator(item.descricao),
                preco: item.preco_default ? item.preco_default : 0,
                quantidade: item.qtd_default ? item.qtd_default : 0,
                status: "ATIVO",
                nidentificador: item.identificador
                  ? [item.identificador]
                  : [item.idvariacao],
                nidvariacao: item.idvariacao
                  ? [item.idvariacao]
                  : [item.identificador],
                idproduto_variacao: item.idproduto_variacao
                  ? item.idproduto_variacao
                  : "",
                id_tmp: item.idproduto_variacao
                  ? item.idproduto_variacao
                  : v1(),
                idprod_var_lote: item.idprod_var_lote
                  ? item.idprod_var_lote
                  : "",
                taxa: item.taxa ? item.taxa : "",
              });
            }
          });
        }

        if (index == 1) {
          element.valor.forEach(item => {
            if (item.descricao != "") {
              variacao.forEach(v => {
                const { pt, en, es } = this.translateDescription(v.descricao);
                variacao2.push({
                  descricao: `<pt_BR>${`${pt} / ${item.descricao}`}</pt_BR><en_US>${
                    en + item.descricao_en_us
                      ? ` / ${item.descricao_en_us}`
                      : ""
                  }</en_US><es_ES>${
                    es + item.descricao_es_es
                      ? ` / ${item.descricao_es_es}`
                      : ""
                  }</es_ES>`,
                  sku: this.$produtos_gerenciar.SKUGenerator(item.descricao),
                  preco: v.preco ? v.preco : item.preco_default,
                  quantidade: v.quantidade ? v.quantidade : item.qtd_default,
                  status: v.status ? v.status : "",
                  nidentificador: [
                    ...v.nidentificador,
                    item.identificador ? item.identificador : item.idvariacao,
                  ],
                  nidvariacao: [
                    ...v.nidvariacao,
                    item.idvariacao ? item.idvariacao : item.identificador,
                  ],
                  idproduto_variacao: v.idproduto_variacao
                    ? v.idproduto_variacao
                    : "",
                  id_tmp: item.idproduto_variacao
                    ? item.idproduto_variacao
                    : v1(),
                  idprod_var_lote: item.idprod_var_lote
                    ? item.idprod_var_lote
                    : "",
                  taxa: item.taxa ? item.taxa : "",
                });
              });
            }
          });
          if (variacao2.length > 0) {
            variacao = variacao2;
          }
        }

        if (index == 2) {
          element.valor.forEach(item => {
            if (item.descricao != "") {
              variacao.forEach(v => {
                const { pt, en, es } = this.translateDescription(v.descricao);
                variacao3.push({
                  descricao: `<pt_BR>${`${pt} / ${item.descricao}`}</pt_BR><en_US>${
                    en + item.descricao_en_us
                      ? ` / ${item.descricao_en_us}`
                      : ""
                  }</en_US><es_ES>${
                    es + item.descricao_es_es
                      ? ` / ${item.descricao_es_es}`
                      : ""
                  }</es_ES>`,
                  sku: this.$produtos_gerenciar.SKUGenerator(item.descricao),
                  preco: v.preco ? v.preco : item.preco_default,
                  quantidade: v.quantidade ? v.quantidade : item.qtd_default,
                  status: v.status ? v.status : "",
                  nidentificador: [
                    ...v.nidentificador,
                    item.identificador ? item.identificador : item.idvariacao,
                  ],
                  nidvariacao: [
                    ...v.nidvariacao,
                    item.idvariacao ? item.idvariacao : item.identificador,
                  ],
                  idproduto_variacao: v.idproduto_variacao
                    ? v.idproduto_variacao
                    : "",
                  id_tmp: item.idproduto_variacao
                    ? item.idproduto_variacao
                    : v1(),
                  idprod_var_lote: item.idprod_var_lote
                    ? item.idprod_var_lote
                    : "",
                  taxa: item.taxa ? item.taxa : "",
                });
              });
            }
          });
          if (variacao3.length > 0) {
            variacao = variacao3;
          }
        }
      });

      this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos = variacao;
    },
  },
  mounted() {
    if (!this.$axios.getLocal("tipos-variacoes")) {
      this.$produtos_gerenciar.getTiposVariacoes();
    }
    this.$produtos_gerenciar.tipo_variacoes =
      this.$axios.getLocal("tipos-variacoes").data;
  },
  destroyed() {
    this.$produtos_gerenciar.cadastro.variacoes.opcoes = [];
    this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos = [];
  },
};
</script>

<style scoped>
.produtos-add-edit-header-variacao {
  width: 487px;
  font-size: 1em;
  align-self: flex-start;
  margin-top: 20px;
  padding-right: 15px;
}

.produtos-add-edit-container1 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}

.row-container {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  margin-top: 10px;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}

.produtos-add-edit-container2 {
  flex: 0 0 auto;
  width: 75%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.produtos-add-edit-container3 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  border-radius: 10px;
  flex-direction: row;
  justify-content: flex-start;
  background-color: #c9c9c9;
}

.produtos-add-edit-container4 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.produtos-add-edit-container5 {
  flex: 0 0 auto;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  border-radius: 15px;
  padding-right: 20px;
  flex-direction: row;
  justify-content: center;
}

.produtos-variacoes-container {
  flex: 0 0 auto;
  width: 100%;
  height: 50%;
  display: block;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.produtos-variacoes-container1 {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  margin-top: 20px;
  flex-direction: column;
  margin-bottom: 30px;
}

.produtos-variacoes-text1 {
  text-transform: initial;
}

.produtos-variacoes-container2 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}

.produtos-variacao-button1 {
  color: var(--dl-color-gray-white);
  height: 30px;
  display: flex;
  border-width: 0px;
  border-radius: 5px;
  flex-direction: row;
  text-decoration: none;
  background-color: var(--dl-color-gray-black);
  margin-right: 10px;
}

.produtos-variacao-button2 {
  color: var(--dl-color-gray-white);
  height: 30px;
  display: flex;
  border-width: 0px;
  border-radius: 5px;
  flex-direction: row;
  text-decoration: none;
  background-color: var(--dl-color-gray-black);
}
</style>
